<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolLibraryManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/library-management/books",
                title: "Books",
                description: "Manage the school library catalogue and book details.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/library-management/book-borrowing",
                title: "Borrowing",
                description: "Record books borrowed by students and staff.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/library-management/book-returns",
                title: "Returns",
                description: "Process returned books and update borrowing records.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/library-management/book-stock-summary",
                title: "Stock Summary",
                description: "Review library stock levels and catalogue availability.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Fine Management",
                description: "Track library fines and outstanding balances.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
